// views/EnumerationView.js
// Propósito: Vista protegida para enumerar URLs comunes en un dominio base.

import React, { useState } from 'react';
import { enumerate } from '../services/api.js';
import { useAuth } from '../context/AuthContext.js';

function EnumerationView() {
  const { token } = useAuth();
  const [baseUrl, setBaseUrl] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [results, setResults] = useState(null);

  async function handleEnumerate(e) {
    e.preventDefault();
    setError(null);
    setResults(null);
    setLoading(true);
    try {
      const data = await enumerate(baseUrl, token);
      setResults(data);
    } catch (e) {
      setError(e.message || 'No se pudo enumerar');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="glass-card p-3 mt-3">
      <h5 className="mb-2">Enumeración de URLs</h5>
      <p className="text-muted mb-3">Prueba rutas comunes para detectar superficies expuestas.</p>
      <form onSubmit={handleEnumerate} className="d-flex gap-2 url-form">
        <input
          type="url"
          className="form-control glass-input"
          placeholder="https://tu-dominio.com"
          value={baseUrl}
          onChange={(e) => setBaseUrl(e.target.value)}
          required
        />
        <button className="btn btn-primary btn-glow" type="submit" disabled={!baseUrl || loading}>
          {loading ? 'Enumerando…' : 'Enumerar'}
        </button>
      </form>

      {error && <div className="alert alert-danger glass-card mt-2">{error}</div>}

      {results && (
        <div className="mt-3 glass-card section-card">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h6 className="m-0">Resultados para {results.baseUrl}</h6>
            <small className="text-muted">{(results.results || []).length} rutas probadas</small>
          </div>
          {(results.results || []).length === 0 ? (
            <div className="empty-state">No se encontraron rutas alcanzables.</div>
          ) : (
            <div className="table-responsive">
              <table className="table table-dark table-striped table-hover align-middle">
                <thead>
                  <tr>
                    <th>Ruta</th>
                    <th>URL</th>
                    <th>Status</th>
                    <th>Reachable</th>
                  </tr>
                </thead>
                <tbody>
                  {results.results.map((r, idx) => (
                    <tr key={idx}>
                      <td>{r.path}</td>
                      <td><a href={r.url} target="_blank" rel="noreferrer">{r.url}</a></td>
                      <td>{r.status}</td>
                      <td>
                        {r.reachable ? (
                          <span className="badge bg-success">Sí</span>
                        ) : (
                          <span className="badge bg-secondary">No</span>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default EnumerationView;
